import React from 'react';
import { Helmet } from 'react-helmet';
import { Box, Button } from '@indeed/ifl-components';
import PageTransition from '../../../components/PageTransition/PageTransition';
import { AutoApplyHeader } from '../../../components/AutoApplyHeader/AutoApplyHeader';
import { usePageFlow } from '../../../lib/pageFlow/usePageFlow';
import { MatchPreferencesSection } from '../components/MatchPreferencesSection';
import { jsProThemeButton } from '../components/jsProTheme/jsProTheme';
import GettextFactory from '../../../util/GettextFactory';
import { useEventLogger } from '../../../lib/eventLogger/EventLoggerProvider';
import { useLocation } from 'react-router-dom';
import { useIsProBrandingEnabled } from '../../../lib/hooks/useIsProBrandingEnabled';
import { useApplyForMeCopy } from '../hooks/useApplyForMeCopy';

const JobPreferencesPage: React.FC = () => {
    const { goForward, loading: pageFlowLoading } = usePageFlow();
    const gt = GettextFactory();
    const eventLogger = useEventLogger();
    const location = useLocation();
    const isProBrandingEnabled = useIsProBrandingEnabled();
    const copy = useApplyForMeCopy();

    const handleContinue = () => {
        eventLogger.logAutoApplySetupButtonClickEvent?.({
            currentPage: location.pathname,
            button: 'continue',
        });
        void goForward();
    };

    return (
        <PageTransition pageKey="auto-apply-job-preferences">
            <Helmet>
                <title>{copy.jobPreferencesTitle}</title>
            </Helmet>

            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 5,
                }}
            >
                <AutoApplyHeader
                    title={gt.gettext('Add job preferences')}
                    description={gt.gettext(
                        "We'll use these preferences from your profile and your activity on Indeed as a guide to select jobs.",
                    )}
                />

                {/* Match Preferences Section - shared component */}
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                    <MatchPreferencesSection />
                </Box>

                <Button
                    onClick={handleContinue}
                    sx={isProBrandingEnabled ? jsProThemeButton.primary : {}}
                    full
                    loading={pageFlowLoading}
                    disabled={pageFlowLoading}
                >
                    {gt.gettext('Continue')}
                </Button>
            </Box>
        </PageTransition>
    );
};

export default JobPreferencesPage;
